export const TRANSFER_SUPPORT_SUPPORT_TYPE = "SUPPORT";
export const TRANSFER_SUPPORT_CONFIRM_TYPE = "CONFIRM";
export const TRANSFER_SUPPORT_AMENDMENT_TYPE = "AMENDMENT";
export const TRANSFER_SUPPORT_REFUND_RECEIVED_TYPE = "REFUND_RECEIVED";
